import { defineMessages } from 'react-intl';

export default defineMessages({
  subnavAria: {
    id: 'rewards.sr6RewardsPage.subnavAria',
    defaultMessage: 'rewards subnav',
    description: '',
  },
  subnavTabHowItWorks: {
    id: 'rewards.sr6RewardsPage.subnavTabHowItWorks',
    defaultMessage: 'How It Works',
    description: '',
  },
  subnavTabMyRewards: {
    id: 'rewards.sr6RewardsPage.subnavTabMyRewards',
    defaultMessage: 'My Rewards',
    description: '',
  },
  questionsBody: {
    id: 'rewards.sr6RewardsPage.questionsBody',
    defaultMessage:
      'We want to help in any way we can. You can ask your barista anytime or we’ve answered the most commonly asked questions <link>right over here</link>.',
    description: 'Body message for SR6 FAQ section',
  },
});
